import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';
import { StoreModule } from '@ngrx/store';
import { appReducer } from './reducer';

@NgModule({
	imports: [CommonModule, StoreModule.forFeature('app', appReducer)],
})
export class AppStoreModule {}
